import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["visible", "children"];
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/core/animation/animation.js",
  _this = this;
import styled, { css, keyframes } from 'styled-components';
import { Transition } from 'react-transition-group';
import React from 'react';
export var FADE_IN_DURATION = 250;
export var FADE_OUT_DURATION = 200;
var fadeIn = keyframes(["from{opacity:0;}to{opacity:1;}"]);
var fadeOut = keyframes(["from{opacity:1;}to{opacity:0;}"]);
export var FadeAnimationContainer = styled.div.withConfig({
  displayName: "animation__FadeAnimationContainer",
  componentId: "sc-gpb3hk-0"
})(["", ""], function (_ref) {
  var state = _ref.state;
  switch (state) {
    case 'entering':
      return css(["animation:", " ease-in ", "ms;"], fadeIn, FADE_IN_DURATION);
    case 'entered':
      return css(["opacity:1;"]);
    case 'exiting':
      return css(["animation:", " ease-out ", "ms;"], fadeOut, FADE_OUT_DURATION);
    case 'exited':
      return css(["opacity:0;"]);
  }
});
export var Fade = function Fade(_ref2) {
  var visible = _ref2.visible,
    children = _ref2.children,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(Transition, {
    timeout: visible ? FADE_IN_DURATION : FADE_OUT_DURATION,
    "in": visible,
    mountOnEnter: true,
    unmountOnExit: true,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 3
    }
  }, function (state) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FadeAnimationContainer, _extends({
      state: state
    }, rest, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 11
      }
    }), children));
  });
};